import * as types from "./sign-up.types";

/* -------------------------------------------------------------------------- */
/*                                   ACTIONS                                  */
/* -------------------------------------------------------------------------- */
export const set_step_1 = (payload) => {
	return {
		payload: payload,
		type: types.SET_STEP_1,
	};
};

export const set_step_2 = (payload) => {
	return {
		payload: payload,
		type: types.SET_STEP_2,
	};
};
